import React from 'react';

const DashboardHeader = () => {
 return (
 <div className="flex justify-between items-center bg-[#111] text-white px-6 py-4 shadow-md rounded-md">
 <h2 className="text-2xl font-bold">Welcome, Admin</h2>
 <div className="flex items-center gap-3">
 <img
        src="https://placehold.co/35"
        alt="Admin"
        className="w-10 h-10 rounded-full border-2 border-gold"
      />
 <span className="text-md">Admin</span>
 </div>
 </div>
 );
};

export default DashboardHeader;



